// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2ycru","calendarButtons":"ClockData_calendarButtons__3Kev_"};